import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../../store';
import Table from '../../../facturotopia/table/Table';

class DashboardClientesList extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
    };
  }

  get columns() {
    return [
      {
        key: 'nombre_comercial',
        title: 'Cliente',
        dataIndex: 'nombre_comercial',
      },
      {
        key: 'finkok',
        title: 'Finkok',
        dataIndex: 'finkok',
        align: 'right',
      },
      {
        key: 'timbox',
        title: 'Timbox',
        dataIndex: 'timbox',
        align: 'right',
      },
      {
        key: 'turbopac',
        title: 'Turbo Pac',
        dataIndex: 'turbopac',
        align: 'right',
      },
      {
        key: 'sw',
        title: 'Smart Web',
        dataIndex: 'sw',
        align: 'right',
      },
      {
        key: 'comprobantes',
        title: 'Comprobantes',
        dataIndex: 'timbrado_comprobantes',
        align: 'right',
      },
      {
        key: 'retenciones',
        title: 'Retenciones',
        dataIndex: 'timbrado_retenciones',
        align: 'right',
      },
      {
        key: 'cancelaciones',
        title: 'Cancelaciones',
        dataIndex: 'cancelaciones',
        align: 'right',
      },
      {
        key: 'total',
        title: 'Total',
        dataIndex: 'total',
        align: 'right',
      },
    ];
  }

  componentDidMount() {
    const { data } = this.props;

    if (data.length === 0) {
      this.paginate(1);
    }
  }

  paginate(meta) {
    const { filters = {} } = this.props;

    this.props.paginate({
      ...filters,
      ...meta,
    });
  }

  handleOnPageChange = (page) => {
    this.paginate({ page });
  };

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  };

  getPaginationConfig() {
    const { pagination } = this.props;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange,
    };
  }

  render() {
    const { columns } = this.state;
    const { data, busy } = this.props;
    const { onRowClick } = this.props;

    const newData = data.map((item) => {
      return {
        ...item,
        nombre_comercial: item.cliente.nombre_comercial,
        timbrado_comprobantes: item.comprobantes ?? 0,
        timbrado_retenciones: item.retenciones ?? 0,
        cancelaciones: item.cancelaciones ?? 0,
        total: parseInt(item.comprobantes) + parseInt(item.retenciones) + parseInt(item.cancelaciones),
      };
    });

    return (
      <Table
        loading={busy}
        columns={columns}
        rowKey={'id'}
        data={newData}
        pagination={this.getPaginationConfig()}
        onRowClick={onRowClick}
      ></Table>
    );
  }
}

const mapState = (state) => {
  return state.admin.dashboard.list;
};

const mapActions = (actions) => {
  return {
    paginate: actions.admin.dashboard.list.paginate,
  };
};

export default connect(useStore, mapState, mapActions)(DashboardClientesList);
